import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  scheduleButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-end'
  }
});
